/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetBreadCrumbNameRequest,
    GetBreadCrumbNameRequestFromJSON,
    GetBreadCrumbNameRequestToJSON,
} from '../models';

export interface ApiBreadcrumbBreadcrumbnamePostRequest {
    getBreadCrumbNameRequest?: GetBreadCrumbNameRequest;
}

/**
 * 
 */
export class BreadcrumbApi extends runtime.BaseAPI {

    /**
     */
    async apiBreadcrumbBreadcrumbnamePostRaw(requestParameters: ApiBreadcrumbBreadcrumbnamePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/api/Breadcrumb/breadcrumbname`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBreadCrumbNameRequestToJSON(requestParameters.getBreadCrumbNameRequest),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiBreadcrumbBreadcrumbnamePost(requestParameters: ApiBreadcrumbBreadcrumbnamePostRequest): Promise<string> {
        const response = await this.apiBreadcrumbBreadcrumbnamePostRaw(requestParameters);
        return await response.value();
    }

}
